import { useCallback } from "react";
import StatusBar16ProMax from "../components/StatusBar16ProMax";
import { useNavigate } from "react-router-dom";
import ProfileDetails from "../components/ProfileDetails";
import FrameComponent5 from "../components/FrameComponent5";

const EditProfile = () => {
  const navigate = useNavigate();

  const onHomeTextClick = useCallback(() => {
    navigate("/41-home");
  }, [navigate]);

  const onKhiBnNhnClick = useCallback(() => {
    navigate("/31-term-2");
  }, [navigate]);

  return (
    <div className="w-full relative bg-light-primary-key-background overflow-hidden flex flex-col items-start justify-start pt-0 px-0 pb-28 box-border gap-[59px] leading-[normal] tracking-[normal]">
      {/* <StatusBar16ProMax
        statusBar16ProMaxBackgroundColor="#fff"
        statusBar16ProMaxPosition="unset"
        statusBar16ProMaxTop="unset"
        statusBar16ProMaxLeft="unset"
      /> */}
      <section className="flex flex-row items-start justify-start pt-0 px-10 pb-1.5 box-border max-w-full text-left text-base text-light-text font-text-regular-lowercase">
        <div className="flex flex-col items-start justify-start gap-10 max-w-full mq330:gap-5">
          <div
            className="relative font-medium cursor-pointer"
            onClick={onHomeTextClick}
          >
            Home
          </div>
          <div className="flex flex-col items-start justify-start gap-[15px] text-21xl text-dark-text">
            <h1 className="m-0 relative text-inherit font-semibold font-[inherit]">
              Sửa tài khoản
            </h1>
            <h3 className="m-0 relative text-5xl font-semibold font-[inherit] text-light-text">
              Cập nhập thông tin cá nhân
            </h3>
          </div>
        </div>
      </section>
      <section className="self-stretch flex flex-col items-start justify-start pt-0 px-0 pb-[11px] box-border gap-10 max-w-full">
        <ProfileDetails />
        <FrameComponent5 />
      </section>
      <section className="self-stretch flex flex-row items-start justify-start py-0 px-10 box-border max-w-full text-center text-base text-light-text font-text-regular-lowercase">
        <div className="flex-1 flex flex-col items-end justify-start gap-5 max-w-full">
          <div
            className="self-stretch relative cursor-pointer"
            onClick={onKhiBnNhnClick}
          >
            <p className="m-0 font-medium">{`Khi bạn nhấn vào cập nhập tài khoản, bạn đã `}</p>
            <p className="m-0">
              <span className="font-medium">{`đồng ý với `}</span>
              <span className="font-semibold font-text-regular-lowercase text-dark-orange">
                điều khoản sử dụng
              </span>
              <span className="font-medium font-text-regular-lowercase text-light-text">
                {" "}
                của chúng tôi.
              </span>
            </p>
          </div>
          <div className="self-stretch rounded-81xl [background:linear-gradient(90deg,_#ff92d7,_#ffbc92)] flex flex-row items-start justify-start py-5 pl-[103px] pr-[102px] box-border max-w-full text-light-primary-key-background mq360:pl-5 mq360:pr-5 mq360:box-border">
            <div className="h-[60px] w-[360px] relative rounded-81xl [background:linear-gradient(90deg,_#ff92d7,_#ffbc92)] hidden max-w-full" />
            <div className="relative font-medium z-[1]">Cập nhập tài khoản</div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EditProfile;
